import BunkeyAPI from "./BunkeyAPI";

export const getAssetById = (workclient, assetId) => {
  return BunkeyAPI({
    url: `clients/${workclient}/assets/${assetId}`,
    method: "get"
  });
};

export const getCommentsDataByAsset = (workclient, assetId) => {
  return BunkeyAPI({
    url: `/clients/${workclient}/objects/${assetId}/comments`,
    method: "GET"
  });
};
